import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd';
import { Link } from "react-router-dom";
import { FaRegUserCircle, FaPowerOff } from 'react-icons/fa'
import styled from 'styled-components'
import FormLogin from "./FormLogin";

import Service from '../../service/Auth'
import Actions from '../../redux/actions'


const ButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    height: 100%;
    margin-right: 7px;
    margin-left: 15px;
    z-index: 999;
    .navbar-button-group__container{
        display: flex;
        align-items: center;
        
        .mobile-icon{
            display: none;
        }
        
        .btn-group{
            button{
                min-width: 120px;
            }
            & > button:not(:first-child){
                margin-left: 10px;
            }
        }

        .icon{
            display: none;
            align-items: center;
        }
    }

    @media only screen and (max-width: 768px) {
        .navbar-button-group__container{
            .mobile-icon{
                display: flex;
                width: 70px;
                align-items: center;
                justify-content: center;
                font-size: 27px;

                .btn-user{
                    margin-right: 5px;
                }
                
            }
            button{ display: none; }
            .icon{ display: flex; }
        }
    }

    @media only screen and (max-width: 450px) {
        .navbar-button-group__container{
            .mobile-icon{
                display: flex;
                width: 70px;
                align-items: center;
                justify-content: center;
                font-size: 27px;

                .btn-user{
                    margin-right: 5px;
                }
                
            }
            button{ display: none; }
            .icon{ display: flex; }
        }
    }
`

export const IconUser = styled(FaRegUserCircle)`
  font-size: 27px;
  margin-right: 3px;
  cursor: pointer;

  @media only screen and (max-width: 767.9px) {
    margin-right: 0px;
  }
`

export default function Index(props) {

    const email = useSelector(state => state.acc.email)
    const dispatch = useDispatch()

    const onToggleLoginPopup = () => {
        dispatch(Actions.popup.toggleVisible(true, 'เข้าสู่ระบบ','', <FormLogin />));
    }

    const onLogout = async () =>{
        let result = await Service.logout()
        if(result){
            dispatch(Actions.acc.setAcc({email: '', approve: false}))
            window.location.href = "/"
        }
    }

    return (
        <ButtonGroup className={"navbar-button-group"}>
            <div className="navbar-button-group__container">
                {email ? (
                <>
                <div className="btn-group has-login">
                    <Link to={'/profile'}><Button className={"navbar-login btn-primary"}>{email}</Button></Link>
                    <Button onClick={onLogout} className="primary btn-secondary"><FaPowerOff/></Button>
                </div>
                <div className="mobile-icon">
                    <IconUser className="btn-user" />
                    <FaPowerOff className="btn-log-off" onClick={onLogout} />
                </div>
                </>
                ): (
                    <>
                <div className="btn-group not-login">
                    <Button onClick={onToggleLoginPopup} className={"navbar-login btn-primary"}>เข้าสู่ระบบ</Button>
                    <Button className="primary"><Link to="/register" >สมัครสมาชิก</Link></Button>
                </div>
                <div className="icon">
                    <IconUser className="btn-login"  onClick={onToggleLoginPopup}/>
                </div>
                    </>
                )}

            </div>
        </ButtonGroup>
    )
}
